import axios from "axios"
import { useMemoize } from "../utils/state"
import { isProduction } from "@custouch/proxy-use"

const request = axios.create({
    baseURL: `https://feature.${isProduction ? "cloud" : "beta"}.custouch.com/open/feature`
})
request.interceptors.response.use(
    (response) => {
        return response.data
    }
)
export const HasFeature = useMemoize((name) => request.get(name))
